// Deploy-local copy of the backend's src/utils/numberFormat.js (Phil's "rule 7", 2026-10-16:
// one formatter per kind of number). The on-screen QBR tables must match the PPTX/DOCX
// exports, which format through the backend copy — keep the two in sync.

// Hours always render with exactly one decimal place ("1.0", "17.1", "0.0"). Returns null for
// a missing or non-numeric value — callers own their own empty-state text.
export function formatHours(value) {
  if (value === null || value === undefined || value === '') return null
  const num = Number(value)
  if (!Number.isFinite(num)) return null
  // +0 normalizes a rounded -0.0 (e.g. -0.04) to "0.0".
  return (Math.round(num * 10) / 10 + 0).toFixed(1)
}

// Counts (tickets, alerts, breaches) render as plain integers, no decimal.
export function formatCount(value) {
  if (value === null || value === undefined || value === '') return null
  const num = Number(value)
  if (!Number.isFinite(num)) return null
  return `${Math.round(num)}`
}
